"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getQuoteService = exports.createInitialQuote = exports.HubspotStages = void 0;
var _gtmService = require("../gtmService/gtmService");
var _cookieService = require("../storage/cookieService");
var _httpClientFactory = require("../api/httpClientFactory");
var HubspotStages = exports.HubspotStages = {
  Quote: 'Quote',
  Purchased: 'Purchased'
};

/**
 * @typedef {Object} Self
 * @property {() => Axios} getHttpClient 
 * @property {(newInstance: Axios) => void} setHttpClient
 * @property {} getCookieService
 */

var MIDDLEWARE_URL = process.env.MIDDLEWARE_BASE_URL;
var BASE_PATH = '/GlmQuote';

/**
 * @param {Self} self
 * @param {string} path 
 */
var buildUrl = function buildUrl(path) {
  var pathWithSlash = !path.startsWith('/') ? "/".concat(path) : path;
  return MIDDLEWARE_URL + BASE_PATH + pathWithSlash;
};

/**
 * 
 * @param {string} partner 
 * @param {string} broker 
 * @param {string} quoteObjectId
 * @returns 
 */
var createInitialQuote = exports.createInitialQuote = function createInitialQuote(partner, broker, quoteObjectId) {
  return {
    partner: partner,
    broker: broker,
    staffId: null,
    siteType: 'PUBLIC',
    quoteObjectId: quoteObjectId,
    web: true,
    tel: false,
    ftf: false
  };
};

/**
 * @param {Self} self
 * @param {Object} initialQuote
 */
var _createNewQuote = function createNewQuote(self, initialQuote) {
  var url = buildUrl('/CreateNewQuote');
  return self.getHttpClient().post(url, initialQuote);
};

/**
 * 
 * @param {Self} self 
 * @param {Object} quote 
 * @returns 
 */
var _setGlmQuote = function setGlmQuote(self, quote) {
  var url = buildUrl('/SetGlmQuote');
  var startTimer = new Date().getTime();
  var gtmService = (0, _gtmService.getGtmService)();
  return self.getHttpClient().post(url, quote).then(function (response) {
    var totalResponse = new Date().getTime() - startTimer;
    gtmService.pushGA3UserTimingTracking({
      timingValue: totalResponse,
      timingCategory: 'Public Customer Timing',
      timingVariable: 'QAPI_SHARE_API_CALL',
      timingLabel: 'CREATE_GLM_QUOTE'
    });
    return response;
  });
};

/**
 * 
 * @param {Self} self 
 * @param {} quote 
 * @returns 
 */
var _createOrUpdateQuoteObjWithHubSpot = function createOrUpdateQuoteObjWithHubSpot(self, quote, hubspotStage) {
  var url = buildUrl("/CreateOrUpdateQuoteObjWithHubSpot/".concat(hubspotStage));
  if (quote) {
    var _self$getCookieServic, _self$getCookieServic2;
    var hubspotUserToken = (_self$getCookieServic = self.getCookieService()) === null || _self$getCookieServic === void 0 ? void 0 : _self$getCookieServic.readCookie('hubspotutk');
    var hubspotOption = (_self$getCookieServic2 = self.getCookieService()) === null || _self$getCookieServic2 === void 0 ? void 0 : _self$getCookieServic2.readCookie('__hs_opt_out');
    var currentUrl = window.location.href;
    if (hubspotUserToken) {
      quote.hubspotUserToken = hubspotUserToken;
    }
    if (hubspotOption) {
      quote.lcoConsentToProcess = hubspotOption === null || hubspotOption === '' || hubspotOption === 'yes' ? 'false' : 'true';
    }
    if (currentUrl) {
      quote.pageUri = currentUrl;
    }
  }
  return self.getHttpClient().post(url, quote);
};

/**
 * 
 * @param {Self} self
 * @param {string} quoteRef 
 *  
 */
var _getQuoteObj = function getQuoteObj(self, quoteRef) {
  return self.getHttpClient().post(buildUrl('/GetQuoteObj'), quoteRef);
};

/**
 * 
 * @param {Self} self 
 * @param {string} quoteObjectId 
 * @returns 
 */
var _validateRetrieveQuote = function validateRetrieveQuote(self, quoteObjectId) {
  var url = buildUrl("/ValidateRetrievecode/".concat(quoteObjectId));
  return self.getHttpClient().get(url);
};

/**
 * 
 * @param {Self} self 
 * @param {string} speciesCode 
 * @param {string} partner 
 * @param {string} broker 
 * @returns 
 */
var _getBreeds = function getBreeds(self, speciesCode, partner, broker) {
  return self.getHttpClient().get(buildUrl("/Breeds/".concat(speciesCode, "/").concat(partner, "/").concat(broker)));
};

/**
 * 
 * @param {Self} self 
 * @param {string} partner 
 * @param {string} broker 
 * @returns {Promise}
 */
var _getVets = function getVets(self) {
  return self.getHttpClient().get(buildUrl('/Vets'));
};

/**
 * 
 * @param {Self} self 
 * @param {string} partner 
 * @param {string} broker 
 * @param {string} policyStartDate iso-formatted date string 
 * @returns 
 */
var _getMedias = function getMedias(self, partner, broker, policyStartDate) {
  return self.getHttpClient().post(buildUrl("/Extras/Medias/".concat(partner, "/").concat(broker)), policyStartDate);
};

/**
 * 
 * @param {Self} self 
 * @param {string} partner 
 * @param {string} broker 
 * @returns 
 */
var _getTitles = function getTitles(self, partner, broker) {
  var url = buildUrl("/Extras/Titles/".concat(partner, "/").concat(broker));
  return self.getHttpClient().get(url);
};

/**
 * 
 * @param {*} self 
 */
var _getGenders = function getGenders(self) {
  var url = buildUrl('/Extras/Genders');
  return self.getHttpClient().get(url);
};
/**
 * 
 * @param {Self} self 
 * @param {string} partner 
 * @param {string} broker 
 * @param {string} code 
 * @param {string} policyStartDate 
 * @returns 
 */
var _validatePromotionCode = function validatePromotionCode(self, partner, broker, code, policyStartDate) {
  return self.getHttpClient().post(buildUrl("/Extras/Promotioncode/Validate/".concat(code, "/").concat(partner, "/").concat(broker)), policyStartDate);
};

/**
 * 
 * @param {Self} self 
 * @param {Object} quote
 * @returns {Promise}
 */
var _updateGlmQuote = function updateGlmQuote(self, quote) {
  var startTimer = new Date().getTime();
  var gtmService = (0, _gtmService.getGtmService)();
  return self.getHttpClient().post(buildUrl('/UpdateGlmQuote'), quote).then(function (response) {
    var totalResponse = new Date().getTime() - startTimer;
    gtmService.pushGA3UserTimingTracking({
      timingValue: totalResponse,
      timingCategory: 'Public Customer Timing',
      timingVariable: 'QAPI_SHARE_API_CALL',
      timingLabel: 'UPDATE_GLM_QUOTE'
    });
    return response;
  });
  ;
};

/**
 * 
 * @param {Self} self 
 * @param {Object} quote 
 * @returns {Promise}
 */
var _createGlmApplication = function createGlmApplication(self, quote) {
  return self.getHttpClient().post(buildUrl('/CreateGlmApplication'), quote);
};

/**
 * 
 * @param {Self} self 
 * @param {Object} quote 
 * @returns 
 */
var _submitGlmApplication = function submitGlmApplication(self, quote) {
  return self.getHttpClient().post(buildUrl('/SubmitGlmApplication'), quote);
};

/**
 * 
 * @param {Self} self 
 * @param {Object} quote 
 * @returns 
 */
var _saveGlmApplication = function saveGlmApplication(self, quote) {
  return self.getHttpClient().post(buildUrl('/SaveGlmApplication'), quote);
};

/**
 * 
 * @param {Self} self 
 * @param {string} partner 
 * @param {string} broker 
 * @returns 
 */
var _getBrandCollectionFee = function getBrandCollectionFee(self, partner, broker) {
  return self.getHttpClient().get(buildUrl("/Extras/GetBrandCollectionFeeByPartnerBroker/".concat(partner, "/").concat(broker)));
};

/**
 * 
 * @param {Axios} httpClient 
 * @returns 
 */
var getQuoteService = exports.getQuoteService = function getQuoteService(_ref) {
  var apiKey = _ref.apiKey,
    clientId = _ref.clientId;
  return function (aHttpClient, aCookieService) {
    var httpClient = aHttpClient !== null && aHttpClient !== void 0 ? aHttpClient : _httpClientFactory.httpClientFactory.create({
      apiKey: apiKey,
      clientId: clientId,
      hasApiKey: true
    });
    var cookieService = aCookieService !== null && aCookieService !== void 0 ? aCookieService : (0, _cookieService.getCookieService)();

    /** @type {Self} */
    var self = {
      getHttpClient: function getHttpClient() {
        return httpClient;
      },
      getCookieService: function getCookieService() {
        return cookieService;
      },
      setHttpClient: function setHttpClient(aHttpClient) {
        httpClient = aHttpClient;
      }
    };
    return {
      /**
       * 
       * @param {Object} initialQuote 
       * @param {string} initialQuote.partner
       * @param {string} initialQuote.broker
       * @param {string} initialQuote.quoteObjectId
       */
      getQuoteObj: function getQuoteObj(quoteRef) {
        return _getQuoteObj(self, quoteRef);
      },
      /**
       * 
       * @param {string} quoteObjectId 
       * @returns 
       */
      validateRetrieveQuote: function validateRetrieveQuote(quoteObjectId) {
        return _validateRetrieveQuote(self, quoteObjectId);
      },
      /**
       * 
       * @param {string} partner 
       * @param {string} broker 
       * @param {string} code 
       * @param {string} policyStartDate 
       */
      validatePromotionCode: function validatePromotionCode(partner, broker, code, policyStartDate) {
        return _validatePromotionCode(self, partner, broker, code, policyStartDate);
      },
      /**
       * 
       * @param {Object} initialQuote 
       * @param {string} initialQuote.partner
       * @param {string} initialQuote.broker
       * @param {string} initialQuote.quoteObjectId
       */
      createNewQuote: function createNewQuote(initialQuote) {
        return _createNewQuote(self, initialQuote);
      },
      /**
       * 
       * @param {Object} quote 
       * @param {string} hubspotStage 
       * @returns {string} quoteObjectId
       */
      createOrUpdateQuoteObjWithHubSpot: function createOrUpdateQuoteObjWithHubSpot(quote, hubspotStage) {
        return _createOrUpdateQuoteObjWithHubSpot(self, quote, hubspotStage);
      },
      /**
       * 
       * @param {string} speciesCode 
       * @param {string} partner 
       * @param {string} broker 
       */
      getBreeds: function getBreeds(speciesCode, partner, broker) {
        return _getBreeds(self, speciesCode, partner, broker);
      },
      /**
       * 
       * @param {Object} quote 
       */
      setGlmQuote: function setGlmQuote(quote) {
        return _setGlmQuote(self, quote);
      },
      /**
       * 
       * @param {Object} quote 
       */
      updateGlmQuote: function updateGlmQuote(quote) {
        return _updateGlmQuote(self, quote);
      },
      /**
       * 
       * @param {Object} quote 
       */
      createGlmApplication: function createGlmApplication(quote) {
        return _createGlmApplication(self, quote);
      },
      /**
       * 
       * @param {Object} quote 
       */
      submitGlmApplication: function submitGlmApplication(quote) {
        return _submitGlmApplication(self, quote);
      },
      /**
       * 
       * @param {Object} quote 
       */
      saveGlmApplication: function saveGlmApplication(quote) {
        return _saveGlmApplication(self, quote);
      },
      getVets: function getVets() {
        return _getVets(self);
      },
      getGenders: function getGenders() {
        return _getGenders(self);
      },
      /**
       * 
       * @param {string} partner 
       * @param {string} broker 
       * @returns 
       */
      getTitles: function getTitles(partner, broker) {
        return _getTitles(self, partner, broker);
      },
      /**
           * 
           * @param {string} partner 
           * @param {string} broker 
           * @param {string} policyStartDate 
           * @returns 
           */
      getMedias: function getMedias(partner, broker, policyStartDate) {
        return _getMedias(self, partner, broker, policyStartDate);
      },
      /**
           * 
           * @param {string} partner 
           * @param {string} broker
           * @returns 
           */
      getBrandCollectionFee: function getBrandCollectionFee(partner, broker) {
        return _getBrandCollectionFee(self, partner, broker);
      }
    };
  };
};